import styled from 'styled-components'

import Modal from 'shared/components/Modal'
import PaymentOption from 'checkout/enums/PaymentOption'
import { Button } from 'shared/components/Button'
import { ClientOnlyPortal } from 'shared/components/ClientOnlyPortal'
import { CloseX } from 'shared/components/Icons/SVGIcons/CloseX'
import { colors } from 'shared/lib'
import { paymentOptionDisplayMap } from 'checkout/utils/paymentOptionDisplayMap'
import { t } from 'localization'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { useEffect } from 'react'

const TP = 'checkout.panels.PaymentMethod.UpdateCurrencyModal'

type UpdateCurrencyModalProps = {
  isOpen: boolean
  onClose: () => void
  onUpdateCurrency: () => void
  selectedPaymentOption: PaymentOption
  trackUpdateCurrency: (event: string) => void
}

export const UpdateCurrencyModal = ({
  isOpen,
  onClose,
  onUpdateCurrency,
  selectedPaymentOption,
  trackUpdateCurrency,
}: UpdateCurrencyModalProps) => {
  const { updateOrderCurrencyRTK } = useCheckoutContext()

  const handleUpdateCurrency = async () => {
    await updateOrderCurrencyRTK()
    trackUpdateCurrency('CURRENCY_UPDATE_OK_TAP')
    onUpdateCurrency()
    onClose()
  }

  useEffect(() => {
    trackUpdateCurrency('CURRENCY_UPDATE_MODAL_VIEW')
  }, [])

  return (
    <ClientOnlyPortal id="updateCurrencyModal" selector=".main-page-layout">
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
          <ModalHeader>
            <Header data-qa="updateCurrencyModalHeader">
              {t(`${TP}.updateCurrencyModalHeader`, 'Update Currency')}
            </Header>
            <CloseButton data-qa="updateCurrencyModalClose" onClick={onClose}>
              <CloseX height="15" width="15" />
            </CloseButton>
          </ModalHeader>
          <ModalBody data-qa="updateCurrencyModalBody">
            {t(`${TP}.updateCurrencyModalBody`, {
              defaultValue: `{paymentOption} is available in USD only. Would you like to update your currency preference to USD?`,
              paymentOption: paymentOptionDisplayMap.get(selectedPaymentOption),
            })}
          </ModalBody>
          <Button
            $fill
            buttonType="primary1"
            onClick={handleUpdateCurrency}
            qaAttr={'UpdateCurrencyModalUpdateButton'}
            type="button"
          >
            {t(`${TP}.updateButton`, 'OK')}
          </Button>
        </ModalContent>
      </Modal>
    </ClientOnlyPortal>
  )
}

const CloseButton = styled.button`
  width: 15px;
  height: 15px;
`
const Header = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: normal;
`
const ModalBody = styled.div`
  color: ${colors.FC2_GREY};
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 40px;
  margin-top: 10px;
`
const ModalContent = styled.div`
  background-color: ${colors.FC2_WHITE};
  padding: 20px;
`
const ModalHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`
